<script setup>
import { computed, } from 'vue';
import { DropdownMenuItem, useForwardProps, } from 'radix-vue';
import { cn, } from '@/utils/ShadcnUtil';

const props = defineProps({
  disabled: { type: Boolean, required: false, default: false },
  textValue: { type: String, required: false, default: '' },
  asChild: { type: Boolean, required: false, default: false },
  as: { type: null, required: false, default: 'div' },
  class: { type: null, required: false, default: '' },
  inset: { type: Boolean, required: false, default: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <DropdownMenuItem
    v-bind="forwardedProps"
    :class="
      cn(
        'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        inset && 'pl-8',
        props.class,
      )
    "
  >
    <slot />
  </DropdownMenuItem>
</template>
